// @flow

// Reference: https://uploadcare.com/docs/processing/
type Operation =
  | {| autoRotate: boolean |}
  | {| preview: string |}
  | {| progressive: boolean |}
  | {| resize: string |}
  | {| scaleCrop: string |}
  | {| format: string |}

const defaultDimensions = '2000x2000'
const mediumDimensions = '1000x1000'
const smallDimensions = '500x500'

export function uuidToUrl(uuid: string) {
  return `https://ucarecdn.com/${uuid}/`
}

export function applyImagePreview(url: string) {
  return applyImageProcessing(url, [{ preview: defaultDimensions }])
}

export function applyMediumImagePreview(url: string) {
  return applyImageProcessing(url, [{ preview: mediumDimensions }])
}

export function applySmallImagePreview(url: string) {
  return applyImageProcessing(url, [{ preview: smallDimensions }])
}

export function applyImageProcessing(url: string, operations: Operation[]) {
  const parts = operations
    .map(operation => {
      if (operation.autoRotate !== undefined) {
        return partForAutoRotate(operation.autoRotate)
      }

      if (operation.preview !== undefined) {
        return partForPreview(operation.preview)
      }

      if (operation.progressive !== undefined) {
        return partForProgressive(operation.progressive)
      }

      if (operation.resize !== undefined) {
        return partForResize(operation.resize)
      }

      if (operation.scaleCrop !== undefined) {
        return partForScaleCrop(operation.scaleCrop)
      }

      if (operation.format !== undefined) {
        return partForFormat(operation.format)
      }

      throw new Error(`received invalid uploadcare operation ${operation}`)
    })
    .join('/-/')

  return parts ? `${url}-/${parts}/` : url
}

function partForAutoRotate(autoRotate: boolean) {
  return `autorotate/${autoRotate ? 'yes' : 'no'}`
}

function partForPreview(preview: string) {
  return `preview${preview && `/${preview}`}`
}

function partForProgressive(progressive: boolean) {
  return `progressive/${progressive ? 'yes' : 'no'}`
}

function partForResize(resize: string) {
  return `resize/${resize}`
}

function partForScaleCrop(scaleCrop: string) {
  return `scale_crop/${scaleCrop}`
}

function partForFormat(format: string) {
  return `format/${format}`
}
